export const configPoint = {
  silver: 20000000,
  gold: 50000000,
  platinum: 150000000,
  diamond: 300000000,
};
